module.exports = __webpack_public_path__ + "assets/events_health_primary.97d84ed6.svg";